import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import { Button, Block, Row, Col, Icon, } from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import ES1Update from "./ES1Update";
import OptionM from "../../components/DynmicOption/OptionM";
import OptionC from "../../components/DynmicOption/OptionC";
import { DownloadTableExcel } from 'react-export-table-to-excel';



const ES1DataView = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Totall, setTotal] = useState([]);
    const [Totall2, setTotal2] = useState([]);
    const [GTotal, setGTotal] = useState(0);
    const [userData, setuserData] = useState("");
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const [Draft, setDraft] = useState(true);
    const [loading, setloading] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const tableRef = useRef(null);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
    });
    const onInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        /* //console.log(formData)*/
    };

    const Total = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES1DetailsTotal1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal(data[0])
                })


    };
    const Total2 = async (empIdd) => {

        const sendData = {

            EmploymentId: Number(empIdd),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES1DetailsTotal2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal2(data[0])
                })


    };

    const getdata2 = async () => {

        const sendData = {

            EmploymentRefId: Number(formData.EmploymentRefId),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Getparameters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*//console.log(data)*/
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                      //console.log(data)
                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2()
                        setuserData(data)
                        Total(data.employmentId)
                        Total2(data.employmentId)
                    }

                })


    };
    const generate = async () => {
        if (formData.year > 0 && formData.month > 0) {
        setloading(false)
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            EmploymentRefId: Number(formData.EmploymentRefId),
            YearId: Number(formData.year),
            MonthId: Number(formData.month),
        }
        /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GenerateEs1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === "Error") {
                        Swal.fire({
                            title: ' This Month Report is Already Submitted',
                            icon: 'error',

                        })
                    } else {
                        setloading(false)
                        getdata()
                    }

                })
    }else {
        Swal.fire({
            icon: "warning",
            title: "Month or Year Not Selected",
            text: "Please Select Month and Year",
            focusConfirm: false,
        }).then(() => {
            props.history.push("/Dashboard")
        })
}
    };
    useEffect(() => {
        if (employmentId > 0) {
            Total(employmentId)
            Total2(employmentId)
        }
    }, [GTotal])

    useEffect(() => {

        setloading(true)
        getdata()

    }, [])

    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }

                /* //console.log(sendData)*/
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/Dashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };



    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata()
    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()

    };

   
    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <Button onClick={() => window.location.href = '/Dashboard'} color="dark"><em class="icon ni ni-back-alt"></em> BACK</Button>

                        
                        <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                            {/*<NavbarDynamic />*/}
                            {localStorage.getItem("urole") === "7" ? <h3 style={{ marginBottom: 40, }}>Employment Return (ES1)   <DownloadTableExcel
                                filename={userData.user !== undefined ?"ES1 Report-"+ userData.user.state :"ES1 Report"}
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                            </DownloadTableExcel></h3> :
                                <h3 style={{ marginBottom: 40, }}>Employment Return (ES1)     <DownloadTableExcel
                                    filename="ES1 Report"
                                    sheet="users"
                                    currentTableRef={tableRef.current}
                                >
                                    <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                </DownloadTableExcel></h3>}
                            
                            {Draft ? <Row className="gy-4">
                                <Col md="6">
                                    <OptionM catid="41" defaultValuemain={formData.dummymonth} onInputChange={onInputChange} namemain="month" mainid="month" />
                                </Col>
                                <Col md="6">
                                    <OptionC catid="42" defaultValuemain={formData.year} onInputChange={onInputChange} namemain="year" mainid="year" />
                                </Col>
                                <Col md="6">
                                    <Button color="success" onClick={() => generate()} >Generate</Button>
                                </Col>
                            </Row> :
                                <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                    <Row className="gy-4">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Name of Employment Exchange: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Month: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    ES 1: Return showing the work done by the Employment Exchanges in respect of all Categories of applicants: <label style={{ fontWeight: "normal" }}>  </label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                        <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <table className="table" id="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <div style={{ visibility: 'hidden', height: 0, width: 0 }}> <tr ><center> Center Name -{userData.user !== undefined ? userData.user.state : "Not Specified"}</center></tr></div>
                                                    <tr >

                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            S. No.

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Description

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Jobseekers on the live Register at the end of previous month

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total number of  registration during  the month   ( includes regisration cards   received on transfer +  fresh  registration + re-registration  made during the month)

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            No. of Jobseekers placed during the month

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                            Registration removed from Live Register during the month* ( includes regisrtation card removed from  Live Register for reason other than Transfer to other  exchanges and regisration cards transferred to other exchanges during the month)
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                            Jobseekers remaining  on the Live Register at the end of month
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Submissions made during the month
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total vacancies  notified during the month
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Vacancies  filled during the month

                                                        </th>


                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {dataactive.length > 0 ? dataactive.map((details) =>

                                                        details.parentId <= 0 ?
                                                            <tr scope="row" >

                                                                <td >
                                                                    {details.parentId === -1 ? null :
                                                                        <b>  {details.sno}</b>
                                                                    }
                                                                </td>

                                                                <td>
                                                                    <b>  {details.name}</b>



                                                                </td>
                                                                {details.parentId === -1 ?
                                                                    <>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.jobseekersCol3}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.totalnumber4}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.noOfJobseekersCol5}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.registrationremovedCol6}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.jobseekersremainingCol7}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.submissionsMadeCol8}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.totalVacanciesCol9}
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                                            {Totall2.vacanciesFilled10}
                                                                        </td>
                                                                    </> : null}
                                                            </tr> :
                                                            <ES1Update edit={false} setGTotal={setGTotal} GTotal={GTotal} sno={details.sno} name={details.name} parametersId={details.parametersId} employmentId={employmentId} ES1Update={ES1Update} />

                                                    ) : null}





                                                    <tr scope="row" >

                                                        <td>

                                                            <b>  </b>

                                                        </td>

                                                        <td>

                                                            <b>  Total</b>

                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.jobseekersCol3}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.totalnumber4}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.noOfJobseekersCol5}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.registrationremovedCol6}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.jobseekersremainingCol7}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.submissionsMadeCol8}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.totalVacanciesCol9}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.vacanciesFilled10}
                                                        </td>

                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>



                                    </div>
                                   
                                </Card>}



                        </Card>

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ES1DataView;
